export enum PushType {

    MediaUploaded = 1



}